import {
  UPDATEFEEMANAGEMENTLIST_SUCCESS,
  UPDATEFEEMANAGEMENTLIST_FAILED,
  RESET_UPDATEFEEMANAGEMENTLIST,
  LOADING_UPDATEFEEMANAGEMENTLIST,
  NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateFeeManagementList = () => {
  return { type: RESET_UPDATEFEEMANAGEMENTLIST };
};

const updateFeeManagementList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UPDATEFEEMANAGEMENTLIST });
  await partnerServices
    .post("updateFeeManagementList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(updateFeeManagementListsuccess(res.data));
          break;
        default:
          dispatch(updateFeeManagementListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST, payload: err });
    });
};
function updateFeeManagementListsuccess(data) {
  return {
    type: UPDATEFEEMANAGEMENTLIST_SUCCESS,
    payload: data,
  };
}
function updateFeeManagementListFailed(data) {
  return {
    type: UPDATEFEEMANAGEMENTLIST_FAILED,
    payload: data,
  };
}

export { resetUpdateFeeManagementList, updateFeeManagementList };
